import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from 'domains/merchant-inbound-reject-return/molecules/table-column'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  hiddenColumns  : PropTypes.arrayOf(PropTypes.string),
  rowButtonProps : PropTypes.shape({
    buttonText    : PropTypes.string,
    buttonColour  : PropTypes.string,
    onButtonClick : PropTypes.func
  })
}


const defaultProps = {
  hiddenColumns  : [],
  isLoading      : false,
  rowButtonProps : {
    buttonText    : 'Process',
    buttonColour  : 'default',
    onButtonClick : () => {}
  }
}

/**
 * Table to display Merchant Inbound columns
 * @param {Array<Object>} data - array of merchant_inbound objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */

const MerchantInboundRejectReturnTable = ({
  data,
  pagination,
  onFetchData,
  hiddenColumns,
  rowButtonProps,
  isLoading
}) => {
  const { buttonText, buttonColour, onButtonClick } = rowButtonProps

  const columns = useMemo(() => tableColumns({
    buttonText,
    buttonColour,
    onButtonClick
  }),
  [
    buttonColour,
    buttonText,
    onButtonClick
  ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

MerchantInboundRejectReturnTable.propTypes    = propTypes
MerchantInboundRejectReturnTable.defaultProps = defaultProps

export default MerchantInboundRejectReturnTable